/**
 * Mirrors backend/src/common/auth/password-policy.ts. Frontend duplicates the rules
 * so the UX shows live checkmarks; the server is still the source of truth.
 */

export interface PasswordCheck {
  id: 'min_length' | 'uppercase' | 'lowercase' | 'digit' | 'special';
  label: string;
  passes: boolean;
}

const SPECIAL_RE = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]/;

export function evaluatePassword(password: string): PasswordCheck[] {
  return [
    { id: 'min_length', label: 'At least 8 characters', passes: password.length >= 8 },
    { id: 'uppercase', label: 'One uppercase letter (A–Z)', passes: /[A-Z]/.test(password) },
    { id: 'lowercase', label: 'One lowercase letter (a–z)', passes: /[a-z]/.test(password) },
    { id: 'digit', label: 'One number (0–9)', passes: /[0-9]/.test(password) },
    { id: 'special', label: 'One special character (e.g. !@#$%^&*)', passes: SPECIAL_RE.test(password) },
  ];
}

export function passwordPasses(password: string): boolean {
  return evaluatePassword(password).every((c) => c.passes);
}
